import { FC, ReactNode } from 'react';
import { Button, Space } from 'antd';
import { TbSelect } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import DataGridSelectionToolbar from '../../tables/DataGridSelectionToolbar';
import SmallTooltip from '../../tooltips/SmallTooltip';

interface CompactListSelectionToolbarProps {
    bottom?: string;
    children?: ReactNode;
    disabled?: boolean;
    itemLabel: string;
    label?: ReactNode;
    loading?: boolean;
    onClear: () => void;
    onSelectAll?: () => void;
    position?: 'absolute' | 'fixed' | 'static';
    selectedCount: number;
    showSelectAll?: boolean;
    visibleCount: number;
}

const CompactListSelectionToolbar: FC<CompactListSelectionToolbarProps> = ({
    bottom,
    children,
    disabled,
    itemLabel,
    label,
    loading = false,
    onClear,
    onSelectAll,
    position = 'fixed',
    selectedCount,
    showSelectAll = true,
    visibleCount,
}): JSX.Element | null => {
    const { token } = useAntDesignTheme();

    if (selectedCount === 0) {
        return null;
    }

    return (
        <DataGridSelectionToolbar
            bottom={bottom}
            label={label ?? `${selectedCount} ${itemLabel}${selectedCount === 1 ? '' : 's'} Selected`}
            loading={loading}
            position={position}
            onClear={onClear}
        >
            <Space.Compact size='small'>
                {showSelectAll && onSelectAll && selectedCount < visibleCount && (
                    <SmallTooltip title={`Select All Visible ${itemLabel}s`} padding='0.5rem 0'>
                        <Button
                            aria-label={`Select all visible ${itemLabel.toLocaleLowerCase()}s`}
                            disabled={disabled || loading}
                            icon={<TbSelect style={{ color: token.colorTextTertiary }} />}
                            onClick={onSelectAll}
                        />
                    </SmallTooltip>
                )}
                {children}
            </Space.Compact>
        </DataGridSelectionToolbar>
    );
};

export default CompactListSelectionToolbar;
